module.exports = __webpack_public_path__ + "static/img/book3.90cfa22.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/book3.png
// module id = qrIL
// module chunks = 1